import React from 'react';
import { AboutThisBookCarousel, AboutThisBookCarouselV2 } from '@novelist/novum-novella-ui';
import AnalyticsWrapperContainer from './AnalyticsWrapperContainer';
import BookSummaryContainer from "./bookSummary/BookSummaryContainer";
import InsideThisBookContainer from "./InsideThisBookContainer"
import AuthorBioContainer from "./authorBiography/AuthorBioContainer"
import AcceleratedReaderFeatureContainer from './acceleratedReader/AcceleratedReaderFeatureContainer';
import ProfessionalReviewsContainer from './ProfessionalReviewsContainer';
import ReaderReviewsContainerV4 from "./ReaderReviewsContainerV4";
import ReadingLevelFeatureContainer from "./ReadingLevelFeatureContainer";
import { getJsonData } from "../../data/DataStore";
import * as GoodReadsSelector from '../../data/GoodReadsSelector';
import * as AuthorBiographySelector from '../../data/AuthorBiographySelector';
import * as AcceleratedReaderSelector from '../../data/AcceleratedReaderSelector';
import * as ReadingLevelSelector from "../../data/ReadingLevelSelector";
import * as ProfessionalReviewSelector from '../../data/ProfessionalReviewSelector';
import * as BookSummarySelector from "../../data/BookSummarySelector";
import * as InsideThisBookSelector from "../../data/InsideThisBookSelector";
import { getLexileSearchData } from '../../data/services/LexileRangeService';
import { getAvailabilityConfiguration } from '../../data/DataStore';
import { getAcceleratedReaderSearchData } from '../../data/services/AcceleratedReaderService';

const AboutThisBookContainer = ({ featureFlags, numberOfLines}) => {

    if(featureFlags.aboutthisbookCarouselVersion() == 2) {
        let jsonData = getJsonData();
        let reviewsModel = GoodReadsSelector.getGoodReads();
        let authorBiography = AuthorBiographySelector.getAuthorBiography(jsonData);
        let professionalReviews = ProfessionalReviewSelector.getGroupedProfessionalReviews(jsonData);
        let bookSummary = BookSummarySelector.getBookSummary(jsonData);
        let insideThisBook = InsideThisBookSelector.getBookContentsAsObject(jsonData);

        const lexileModel = ReadingLevelSelector.getLexile();
        const getLexileData = (min, max, finalCallback) => {
            getLexileSearchData(min, max, lexileModel.audienceLevel, finalCallback);
        }

        let arModel = AcceleratedReaderSelector.getAcceleratedReader(jsonData);
        const getAcceleratedReaderData = (bookLevel, interestLevel, finalCallback) => {
            getAcceleratedReaderSearchData(bookLevel, interestLevel, finalCallback);
        }

        if(reviewsModel || authorBiography || (professionalReviews && professionalReviews.length > 0) || bookSummary || insideThisBook || arModel || lexileModel){
            return (<AnalyticsWrapperContainer
                    Component={
                    <AboutThisBookCarouselV2 
                        goodReadsProps={reviewsModel} 
                        authorBiographyProps={authorBiography} 
                        acceleratedReaderProps={arModel ? {
                            audienceLevel: arModel.audienceLevel,
                            bookLevel: arModel.bookLevel,
                            interestLevel: arModel.interestLevel,
                            getAcceleratedReaderData: getAcceleratedReaderData
                        } : undefined}
                        lexileProps={ {
                            lexile: lexileModel ? lexileModel.lexile: "",
                            getLexileData: getLexileData
                        }}
                        professionalReviewsProps={ {
                            reviewPublications: professionalReviews
                        }}
                        bookSummaryProps={bookSummary}
                        insideThisBookProps={insideThisBook}
                        availabilityConfiguration={getAvailabilityConfiguration()}
                    />}
                    componentName={'About This Book'}
                    featureType={'About This Book'}
                />)
        }
        return null;
    }
    else {
        let aboutThisBookItems = [
            <ReaderReviewsContainerV4 uiVersionFlag={featureFlags.novelistSelectUiVersion()} />,
            <ReadingLevelFeatureContainer />,
            <AcceleratedReaderFeatureContainer />,
            <ProfessionalReviewsContainer />,
            <BookSummaryContainer numberOfLines={numberOfLines} />,
            <AuthorBioContainer numberOfLines={numberOfLines} />,
            <InsideThisBookContainer />,
        ];
    
        return (
            <AnalyticsWrapperContainer
                Component={<AboutThisBookCarousel carouselItems={aboutThisBookItems} />}
                componentName={'About This Book'}
                featureType={'About This Book'}
            />
        );
    }
}

export default AboutThisBookContainer; 



// WEBPACK FOOTER //
// ./src/react/containers/AboutThisBookContainer.jsx